function NRBitbucket({ height = '24', width = '24', color = '#2684FF' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.64886 2.90899C2.55537 2.90777 2.46275 2.92726 2.37751 2.96608C2.29226 3.0049 2.21645 3.06211 2.1554 3.1337C2.09436 3.2053 2.04955 3.28953 2.02413 3.38049C1.99871 3.47145 1.99329 3.56694 2.00826 3.66024L4.7276 20.3497C4.76148 20.554 4.86546 20.7396 5.02128 20.874C5.17709 21.0085 5.37477 21.0831 5.5796 21.0848H18.6254C18.7789 21.0868 18.9281 21.033 19.0457 20.9331C19.1632 20.8333 19.2414 20.694 19.266 20.5408L21.9917 3.66672C22.0067 3.57342 22.0013 3.47793 21.9759 3.38697C21.9505 3.29601 21.9056 3.21177 21.8446 3.14018C21.7836 3.06859 21.7077 3.01137 21.6225 2.97255C21.5372 2.93373 21.4446 2.91425 21.3511 2.91547L2.64886 2.90899ZM14.0996 14.9711H9.93567L8.80822 9.0194H15.1085L14.0996 14.9711Z"
        fill={color}
      />
      <path
        d="M21.1205 9.01941H15.1085L14.0995 14.9712H9.93564L5.01904 20.8743C5.17488 21.0106 5.37356 21.0863 5.57957 21.088H18.6286C18.7821 21.09 18.9313 21.0362 19.0488 20.9364C19.1664 20.8365 19.2446 20.6973 19.2692 20.544L21.1205 9.01941Z"
        fill="url(#paint0_linear_637_2220)"
      />
      <defs>
        <linearGradient id="paint0_linear_637_2220" x1="22.5106" y1="10.6838" x2="12.4929" y2="18.4205" gradientUnits="userSpaceOnUse">
          <stop offset="0.18" stopColor="#0052CC" />
          <stop offset="1" stopColor={color} />
        </linearGradient>
      </defs>
    </svg>
  );
}
export default NRBitbucket;
